import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IAlbum, Lightbox, LightboxConfig } from 'ngx-lightbox';
import { Observable } from 'rxjs';
import { ShopService } from '../shop.service';

@Component({
  selector: 'app-shop-details',
  templateUrl: './shop-details.component.html',
  styleUrls: ['./shop-details.component.css']
})
export class ShopDetailsComponent implements OnInit {
  _shopId: string;
  shop$: Observable<any>;
  pictures$: Promise<string[]>;
  @Input()
  displayHeader = true;

  constructor(private route: ActivatedRoute, private shopService: ShopService, private lightbox: Lightbox, private _lightboxConfig: LightboxConfig) {
    _lightboxConfig.disableScrolling = true;
  }

  get shopId(): string {
    return this._shopId;
  }

  @Input()
  set shopId(shopId: string) {
    this._shopId = shopId;
    this._updateContent(shopId);
  }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.shopId = this.route.snapshot.paramMap.get('id');
    }
  }

  _updateContent(shopId: string) {
    console.log(`Let's display shop ${shopId}`);
    this.shop$ = this.shopService.getShop(shopId);
    this.pictures$ = this.shopService.getShopPictures(shopId);
  }

  async displayImage(index: number): Promise<void> {
    const pictures = await this.pictures$;
    const album = pictures.map(item => {
      return {
        src: item,
      } as IAlbum;
    })
    this.lightbox.open(album, index);
  }
}
